<template>
  <IziPage>
    <IziGrid>
      <IziCol xl="2" />
      <IziCol xl="8">
        <Settings />
      </IziCol>
      <IziCol xl="2" />
    </IziGrid>
  </IziPage>
</template>
<script lang="ts">
import { Vue } from "vue-class-component";
export default class SetupChallenge extends Vue {}
</script>
<style lang="scss"></style>
